import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.dark,
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  topContainer: {
    position: "relative",
    width: "100%",
  },
  bg: {
    position: "absolute",
    left: "-100px",
    [theme.breakpoints.down("md")]: {
      left: "-50px",
    },
    maxWidth: "100%",
    marginTop: "60px",
  },
  mainContainer: {
    marginTop: "200px",
    marginBottom: "200px",
    position: "relative",
    padding: theme.spacing(4, 3),
    flex: 1,
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  card: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    boxShadow: "0px 4px 14px rgba(0, 0, 0, 0.08)",
    border: "1px solid rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(3),
  },
  title: {
    ...theme.typography.h5,
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
  subTitle: {
    ...theme.typography.h6,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
  sectionTitle: {
    ...theme.typography.h6,
    fontWeight: 700,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  sectionText: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  faqList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  faqAccordion: {
    backgroundColor: theme.palette.grey[100],
    borderRadius: `${theme.spacing(1.5)} !important`,
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
  },
  faqSummary: {
    padding: theme.spacing(0.5, 1),
    minHeight: "unset",
    "& .MuiAccordionSummary-content": {
      margin: theme.spacing(1.5, 0),
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: theme.spacing(1.5, 0),
    },
  },
  faqIcon: {
    color: theme.palette.common.black,
  },
  faqQuestion: {
    ...theme.typography.h6,
    fontWeight: 500,
    fontSize: "1rem",
    color: theme.palette.common.black,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
  faqDetails: {
    padding: theme.spacing(0, 2, 2, 2),
  },
  faqAnswer: {
    ...theme.typography.body1,
    fontSize: "0.95rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
    },
  },
  helperText: {
    ...theme.typography.body2,
    color: theme.palette.text.disabled,
  },
  ticketList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  ticketCard: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1.5),
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
    padding: theme.spacing(2.5),
  },
  ticketHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
  },
  ticketTitle: {
    ...theme.typography.subtitle1,
    fontWeight: 700,
    color: theme.palette.text.secondary,
  },
  ticketMeta: {
    ...theme.typography.caption,
    color: theme.palette.text.disabled,
  },
  ticketDates: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(0.5),
    },
  },
  ticketActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
  linkButton: {
    background: "none",
    border: "none",
    color: theme.palette.primary.main,
    cursor: "pointer",
    fontWeight: 600,
  },
  statusChip: {
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(3),
    fontSize: "0.75rem",
    fontWeight: 600,
    textTransform: "capitalize",
  },
  statusOpen: {
    backgroundColor: "rgba(39, 111, 191, 0.1)",
    color: theme.palette.info.main,
  },
  statusInProgress: {
    backgroundColor: "rgba(250, 119, 81, 0.1)",
    color: theme.palette.warning.main,
  },
  statusClosed: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    color: theme.palette.text.disabled,
  },
  emptyState: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4, 2),
    border: "1px dashed rgba(0, 0, 0, 0.2)",
    borderRadius: theme.spacing(2),
  },
  centerButton: {
    display: "flex",
    justifyContent: "center",
  },
  sendContainer:{
     display: "flex",
    justifyContent: "center",

  },
  footerContainer: {
    background: theme.palette.primary.dark,
    width: "100%",
  },
  footerWrapper: {
    backgroundColor: theme.palette.primary.main,
    width: "90%",
    display: "flex",
    marginLeft: "auto",
    borderTopLeftRadius: "5rem",
    borderBottomLeftRadius: "5rem",
  },
  modalContent: {
    padding: theme.spacing(0),
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: theme.palette.text.secondary,
    color: theme.palette.common.white,
    padding: theme.spacing(2),
  },
  modalTitle: {
    ...theme.typography.subtitle1,
    fontWeight: 700,
  },
  modalClose: {
    color: theme.palette.common.white,
  },
  modalBody: {
    padding: theme.spacing(3),
  },
  modalLabel: {
    ...theme.typography.subtitle1,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  modalSubText: {
    ...theme.typography.body2,
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
